// extracted by mini-css-extract-plugin
export default {"root":"s14_n","link":"HFYLF"};